import {
  ACTION_GET_BOOKING,
  ACTION_GET_BOOKING_SUCCESS,
  ACTION_GET_BOOKING_FAILURE,
  ACTION_EMPTY_BOOKING,
  ACTION_POST_BOOKING_NEW_PAYMENT_SUCCESS,
  ACTION_POST_REFUND_BOOKING_SUCCESS,
  ACTION_PUT_BOOKINGS_CUSTOM_TAG,
  ACTION_PUT_BOOKINGS_CUSTOM_TAG_SUCCESS,
  ACTION_PUT_BOOKINGS_CUSTOM_TAG_FAILURE,
  ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE,
  ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE_SUCCESS,
  ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE_FAILURE,
  ACTION_PUT_CANCEL_BOOKING_SUCCESS,
  ACTION_PUT_UPDATE_BOOKING_SUCCESS,
  ACTION_POST_BOOKING_FLIGHTCREDITS_SUCCESS,
  ACTION_POST_BOOKING_FLIGHTCREDITS,
} from '../configs/ActionTypes';

import * as _ from 'lodash-es';

const initialState = {
  booking: null,
  isLoading: false,
  success: null,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_GET_BOOKING:
    case ACTION_PUT_BOOKINGS_CUSTOM_TAG:
    case ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case ACTION_GET_BOOKING_SUCCESS: {
      const b = action.payload.payload;

      let booking: any = b;

      return {
        ...state,
        isLoading: false,
        booking: booking,
        success: true,
      };
    }

    case ACTION_POST_BOOKING_NEW_PAYMENT_SUCCESS:
    case ACTION_POST_REFUND_BOOKING_SUCCESS: {
      let booking = state.booking as any;
      _.set(
        booking,
        'transactions',
        _.get(action.payload.payload, 'transactions', []),
      );

      return {
        ...state,
        booking: booking,
      };
    }

    case ACTION_PUT_BOOKINGS_CUSTOM_TAG_SUCCESS: {
      let booking: any = _.clone(state.booking);
      const tagsId = action.payload.payload.tags;
      let tags = _.get(booking, 'possibleTags', []).filter((obj: any) =>
        tagsId.includes(obj.id),
      );

      booking.tags = tags;

      return {
        ...state,
        booking,
        isLoading: false,
        success: true,
      };
    }

    case ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE_SUCCESS: {
      return {
        ...state,
        booking: {
          ...state.booking,
          customFields: action.payload?.payload ?? [],
        },
        isLoading: false,
        success: true,
      };
    }

    case ACTION_GET_BOOKING_FAILURE:
    case ACTION_PUT_BOOKINGS_CUSTOM_TAG_FAILURE:
    case ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE_FAILURE: {
      return {
        ...state,
        success: false,
        isLoading: false,
      };
    }

    case ACTION_EMPTY_BOOKING: {
      return initialState;
    }

    case ACTION_PUT_CANCEL_BOOKING_SUCCESS: {
      let booking: any = state.booking;
      _.set(booking, 'status', 'canceled');

      return {
        ...state,
        booking,
      };
    }
    case ACTION_POST_BOOKING_FLIGHTCREDITS: {
      return {
        ...state,
        attemptedFlightCreditAdd: true,
      };
    }

    case ACTION_POST_BOOKING_FLIGHTCREDITS_SUCCESS: {
      const ticketNumber: string = action.payload.payload.ticketNumber;
      const booking: any = state.booking;
      _.set(booking, 'flightCreditRecord.ticketNumber', ticketNumber);
      return {
        ...state,
        booking,
      };
    }

    case ACTION_PUT_UPDATE_BOOKING_SUCCESS: {
      const payload = action.payload.payload;
      let booking: any = state.booking;

      _.set(booking, 'confirmationNumber', payload.confirmationNumber);
      _.set(booking, 'status', payload.status);
      _.set(booking, 'notes', payload.notes);

      // Only apply pricing/date fields that are explicitly present in the response.
      // This prevents wiping existing state when backend omits optional values.
      const mergeableFields = [
        'basePrice',
        'taxPrice',
        'totalPrice',
        'customerPrice',
        'requiredCharges',
        'providerReturnDate',
        'arrivalDate',
        'endDate',
        'dropOffDate',
      ];
      for (const field of mergeableFields) {
        if (Object.prototype.hasOwnProperty.call(payload, field)) {
          _.set(booking, field, payload[field]);
        }
      }

      if (payload.type === 'hotel') {
        if (payload.basePrice !== undefined)
          _.set(booking, 'basePrice', payload.basePrice);
        if (payload.totalPrice !== undefined)
          _.set(booking, 'totalPrice', payload.totalPrice);
        if (payload.customerPrice !== undefined)
          _.set(booking, 'customerPrice', payload.customerPrice);
        if (payload.departureDate !== undefined) {
          _.set(booking, 'departureDate', payload.departureDate);
          _.set(booking, 'endDate', payload.endDate);
        }
      }

      if (payload.type === 'flight' && payload.segments) {
        let currentSegmentCounter = 0;
        const newSegments = booking.segments.map((segmentGroup: any) => {
          const segment = segmentGroup.segment.map((singleSegment: any) => {
            currentSegmentCounter++;
            return { ...payload.segments[currentSegmentCounter - 1] };
          });
          return {
            ...segmentGroup,
            from: segment?.[0]?.from,
            to: segment?.[segment.length - 1]?.to,
            segment,
          };
        });

        _.set(booking, 'segments', newSegments);
      }

      return {
        ...state,
        booking,
      };
    }

    default: {
      return state;
    }
  }
}
